'use strict';

var EventEmitter = require('events').EventEmitter;

var _ = require('lodash');
var ReactDispatcher = require('flux-react-dispatcher');

var at = require('../utils/environment');


var ItemStore = function(initialItems) {
    this._renderedItems = [];
    if (at.server || _.isArray(initialItems)) {
        this._add(initialItems);
    }
    if (at.client) {
        this.dispatcher = new ReactDispatcher();
        this.dispatcher.register(this, this.dispatch);
    }
};

ItemStore.prototype = {
    errorMessages: {
        ADD: _.template("<%= arg %> can't be added. Expected an array.")
    },

    _add: function(items) {
        if (_.isArray(items)) {
            this.grantItemKey(items);
            this._renderedItems.push.apply(this._renderedItems, items);
        } else throw this.errorMessages.ADD({arg: items});
    },

    grantItemKey: function(items) {
        var item;
        var iterations = items.length;

        while (iterations--) {
            item = items[iterations];
            item.key = (item.key || item.id || Math.random());
        }
    },

    all: function() {
        return this._renderedItems;
    },

    dispatch: function(payload) {
        switch (payload.eventName) {

            case 'add':
                this._add(payload.items);
                this.emit('change');
                break;

            default:
                console.log('There is no such event:', payload.eventName);
        }
    }
};

_.extend(ItemStore.prototype, EventEmitter.prototype);

module.exports = ItemStore;
